export default "__VITE_ASSET__fc0559e2__"